// extracted by mini-css-extract-plugin
export default {"imageWrapper":"aT-z","hovered":"bT-z","hoverImage":"cT-z","mainImage":"dT-z","imageNoBackground":"eT-z","fullSizeImage":"fT-z"};